export enum APP_LOADER_COLOR {
   PRIMARY = "PRIMARY",
   SECONDARY = "SECONDARY",
   DISABLED = "DISABLED",
}


export interface AppLoaderProps {
   /** Szerokość całego loadera (np. "40px", 40, "50%") */
   height?: string | number;
   /** Grubość obwódki (np. "4px", 3, '1em") */
   barWidth?: string | number
   /** Kolor loadera */
   color?: APP_LOADER_COLOR;
   /** Dodatkowa klasa CSS */
   className?: string;
   /** Tekst alternatywny do czytników ekranu */
   ariaLabel?: string;
}